import { useMutation, useQueryClient } from "@tanstack/react-query";
import serialsClient, { GenerationStatus } from "../../../api/serials";

const useGenerateBatchMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ count, prefix }: { count: number; prefix?: string }) =>
      serialsClient.generateBatch(count, prefix),
    // Mark generation as running immediately — the poll would otherwise take
    // up to 30s to notice, leaving the Generate button enabled mid-run.
    onMutate: () => {
      queryClient.setQueryData<GenerationStatus>(
        ["serials", "generation-status"],
        { running: true, startedAt: new Date().toISOString() },
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["serials", "batches"] });
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ["serials", "generation-status"],
      });
    },
  });
};

export default useGenerateBatchMutation;
